/******************************************************
 * 【共通】ハンバーガーメニュー内モーダル：背景blurアニメーション
 *****************************************************/
const blurAnime_modal = function () {
  const pinWrapper = $('#js-modalBg');
  pinWrapper.css('min-height', innerHeight);

  // 各シェイプのアニメーション
  const shapes = [
    { selector: '#js-modalShape2', x: -80, y: -100, duration: 4 },
    { selector: '#js-modalShape3', x: -400, y: 50, duration: 6 },
    { selector: '#js-modalShape4', x: -300, y: -100, duration: 5 },
    { selector: '#js-modalShape5', x: 300, y: 100, duration: 8 },
    { selector: '#js-modalShape6', x: -200, y: 300, duration: 6 },
    {
      selector: '#js-modalShape7',
      backgroundColor: '#D2EEF5',
      duration: 3,
      repeat: -1,
      yoyo: true,
      repeatDelay: 3,
    },
    { selector: '#js-modalShape8', x: -400, y: -30, duration: 7 },
    { selector: '#js-modalShape9', x: -300, y: -100, duration: 6 },
    { selector: '#js-modalShape10', x: 200, y: 100, duration: 5 },
    { selector: '#js-modalShape11', x: -1000, y: -100, duration: 10 },
    {
      selector: '#js-modalShape13',
      x: -200,
      backgroundColor: '#D2EEF5',
      duration: 3,
      repeat: -1,
      yoyo: true,
      repeatDelay: 3,
    },
  ];

  shapes.forEach((shape) => {
    gsap.to(shape.selector, {
      x: shape.x,
      y: shape.y,
      backgroundColor: shape.backgroundColor,
      repeat: -1,
      yoyo: true,
      duration: shape.duration,
      ease: back.inOut,
    });
  });
};

/******************************************************
 * 【共通】MV：背景blurアニメーション
 *****************************************************/
const blurAnime_mvBg = function () {
  const pinWrapper = $('.c-container');
  pinWrapper.css('min-height', innerHeight);

  // 各シェイプのアニメーション
  const shapes = [
    { selector: '#js-mvBgShape2', x: -80, y: -100, duration: 4 },
    { selector: '#js-mvBgShape3', x: -400, y: 50, duration: 6 },
    { selector: '#js-mvBgShape4', x: -300, y: -100, duration: 5 },
    { selector: '#js-mvBgShape5', x: 300, y: 100, duration: 8 },
    { selector: '#js-mvBgShape6', x: -200, y: 300, duration: 6 },
    {
      selector: '#js-mvBgShape7',
      backgroundColor: '#D2EEF5',
      duration: 3,
      repeat: -1,
      yoyo: true,
      repeatDelay: 3,
    },
    { selector: '#js-mvBgShape8', x: -400, y: -30, duration: 7 },
    { selector: '#js-mvBgShape9', x: -300, y: -100, duration: 6 },
    { selector: '#js-mvBgShape10', x: 200, y: 100, duration: 5 },
    { selector: '#js-mvBgShape11', x: -1000, y: -100, duration: 10 },
    {
      selector: '#js-mvBgShape13',
      x: -200,
      backgroundColor: '#D2EEF5',
      duration: 3,
      repeat: -1,
      yoyo: true,
      repeatDelay: 3,
    },
  ];

  shapes.forEach((shape) => {
    gsap.to(shape.selector, {
      x: shape.x,
      y: shape.y,
      backgroundColor: shape.backgroundColor,
      repeat: -1,
      yoyo: true,
      duration: shape.duration,
      ease: Back.easeInOut,
    });
  });
};

window.addEventListener('DOMContentLoaded', blurAnime_mvBg, false);
